import React from 'react'
import { Box, IcoMoon } from '@usap/uicomponents'

export default function Avatar({
  background,
  Icon,
  IcoSize,
  IconColor = 'white',
  Height = '34px',
  Width = '34px',
  border = null,
  viewBoxProp,
}) {
  return (
    <>
      <Box align="center" justify="center" style={{ minWidth: 34 }}>
        <Box
          justify="center"
          align="center"
          margin="xsmall"
          width={Width}
          height={Height}
          round="50%"
          background={background}
          border={border}
        >
          <IcoMoon icon={Icon} color={IconColor} size={IcoSize} viewBoxProp={viewBoxProp} />
        </Box>
      </Box>
    </>
  )
}
